// src/client/utils/creditScoreUtils.ts
import { kwachaToNgwee, type Ngwee } from '@/lib/types';
import type { CreditTier } from '@client/lib/creditScore.types';

export function tierFromScore(score: number): CreditTier {
  if (score >= 80) return 'excellent';
  if (score >= 60) return 'strong';
  if (score >= 40) return 'established';
  if (score >= 20) return 'building';
  return 'new';
}

const MAX_LOAN: Record<CreditTier, Ngwee> = {
  new:         kwachaToNgwee(500),
  building:    kwachaToNgwee(1500),
  established: kwachaToNgwee(5000),
  strong:      kwachaToNgwee(10_000),
  excellent:   kwachaToNgwee(20_000),
};

const AUTO_APPROVE: Record<CreditTier, Ngwee> = {
  new:         kwachaToNgwee(0),
  building:    kwachaToNgwee(0),
  established: kwachaToNgwee(2000),
  strong:      kwachaToNgwee(5000),
  excellent:   kwachaToNgwee(10_000),
};

export function maxLoanForTier(tier: CreditTier): Ngwee {
  return MAX_LOAN[tier];
}

export function autoApproveLimitForTier(tier: CreditTier): Ngwee {
  return AUTO_APPROVE[tier];
}
